module.exports = __webpack_public_path__ + "img/244.32c83572.svg";